import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { PaymentsRoutingModule } from './payments-routing.module';
import { PaymentsComponent } from './payments.component';
import { SharedModule } from "../../shared/shared.module";
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { CashCloseComponent } from './cash-close/cash-close.component';
import { AutofocusDirective } from './autoFocus.directive';
import { PayBookingComponent } from './pay-booking/pay-booking.component';
import { PaymentsSummaryComponent } from './payments-summary/payments-summary.component';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { DetailPaymentComponent } from './detail-payment/detail-payment.component';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ListboxModule } from 'primeng/listbox';
import { InvoicesComponent } from './invoices/invoices.component';
import { TicketsComponent } from './invoices/tickets/tickets.component';
import { EditComponent } from './invoices/edit/edit.component';
import { CashRegisterComponent } from './cash-register/cash-register.component';
import { CalendarModule } from 'primeng/calendar';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProformasComponent } from './proformas/proformas.component';
import { CreateComponent } from './invoices/create/create.component';
import { PaymentsNewComponent } from './payments-new/payments-new.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

@NgModule({
    declarations: [
        PaymentsComponent,
        CashCloseComponent,
        AutofocusDirective,
        PayBookingComponent,
        PaymentsSummaryComponent,
        DetailPaymentComponent,
        InvoicesComponent,
        TicketsComponent,
        EditComponent,
        CashRegisterComponent,
        ProformasComponent,
        CreateComponent,
        PaymentsNewComponent
    ],
    imports: [
        CommonModule,
        PaymentsRoutingModule,
        SharedModule,
        DropdownModule,
        FormsModule,
        ReactiveFormsModule ,
        TabViewModule,
        DialogModule,
        RadioButtonModule,
        ButtonModule,
        ToastModule,
        MessagesModule,
        TooltipModule,
        AutoCompleteModule,
        ListboxModule,
        TableModule,
        CalendarModule,
        NgxExtendedPdfViewerModule,
        ConfirmDialogModule,
        InputNumberModule,
        SweetAlert2Module.forRoot()
    ],
    exports: [
      AutofocusDirective,
    ],
    providers: [
      MessageService
    ]
})
export class PaymentsModule { }
